import { Component, OnInit } from "@angular/core";
import { FormComponentLookup } from "@ptl/forms";
import { setSEPLifeEventDocumentInfo } from "src/app/angular-elements/shared/components/configs/reducers/life-event.reducer";
import { FileDisplayWithModalComponent } from "../../../required-docs-upload/file-display/variants/file-display-with-modal/file-display-with-modal.component";
import { SpecialEnrollmentEventDocumentUploadComponent } from "../../special-enrollment-event-document-upload.component";

// This one includes the document note
@FormComponentLookup("dynamic-special-enrollment-event-document-upload")
@Component({
  selector: "app-dynamic-special-enrollment-event-document-upload",
  templateUrl:
    "./dynamic-special-enrollment-event-document-upload.component.html",
  styleUrls: [
    "./../../special-enrollment-event-document-upload.component.scss",
    "./dynamic-special-enrollment-event-document-upload.component.scss",
  ],
  standalone: false
})
export class DynamicSpecialEnrollmentEventDocumentUpload
  extends SpecialEnrollmentEventDocumentUploadComponent
  implements OnInit
{
  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  saveResponseToState(fileComponent: FileDisplayWithModalComponent) {
    const documentData = {
      ...fileComponent.displayableFileObj,
      documentNote: fileComponent?.displayableFileObj?.documentDescription,
    };

    this.ngRedux.dispatch(setSEPLifeEventDocumentInfo(documentData));
  }
}
